import { Box, Button } from "@mui/material";

export default function CoolingEnergyButton({ setOpenCoolingEnergyModel }: any) {
  return (
    <Box
      sx={{
        display: "flex",
        marginRight: "31px",
      }}
    >
      <Button
        variant="outlined"
        color="primary"
        size="medium"
        sx={{
          borderColor: "#2196F380",
          fontSize: "16px",
        }}
        onClick={() => setOpenCoolingEnergyModel(true)}
      >
        Cooling Energy Model
      </Button>
    </Box>
  );
}
